<template>
  <div class="content">
    <div class="d-flex align-center h-100">
      <v-card class="mx-auto pa-10" elevation="8" width="400" max-width="448" rounded="lg">
        <v-card-title>
          <v-img class="mx-auto" max-width="228" src="@/assets/images/logo-wide.jpg" />
          <div class="text-center text-h5">Reestablecer Contraseña</div>
        </v-card-title>
        <v-card-text>
          <div class="my-5" v-if="!output.send">
            <v-text-field v-model="form.pwd1" density="compact" placeholder="Nueva contraseña" 
            :append-inner-icon="visiblepwd1 ? 'mdi-eye-off' : 'mdi-eye'" 
            :type="visiblepwd1 ? 'text' : 'password'"
            variant="outlined" 
            :error-messages="v$.pwd1.$errors.map(e => e.$message)"
            @click:append-inner="visiblepwd1 = !visiblepwd1"/>

            <v-text-field v-model="form.pwd2" density="compact" placeholder="Confirmar contraseña" 
            :append-inner-icon="visiblepwd2 ? 'mdi-eye-off' : 'mdi-eye'" 
            :type="visiblepwd2 ? 'text' : 'password'"
            variant="outlined" 
            :error-messages="v$.pwd2.$errors.map(e => e.$message)"
            @click:append-inner="visiblepwd2 = !visiblepwd2"/>
            <v-btn 
              color="orange" 
              size="large" 
              variant="tonal" 
              block 
              text="Reestblecer" 
              :loading="output.loading"
              @click="reset()"/>
          </div>
          <div v-if="output.send">
            <v-alert color="info" variant="tonal" title="¡Cambio exitoso!" v-if="!output.failed">
              <div class="text-medium-emphasis text-caption">
                Tu contraseña ha sido actualizada correctamente.
              </div>
            </v-alert>
            <v-alert color="error" variant="tonal" title="Error" v-if="output.failed">
              <div class="text-medium-emphasis text-caption">
                {{ output.message }}
              </div>
            </v-alert>
            <div>
              <v-btn class="my-5" block variant="tonal" color="blue" @click="$router.push({name: 'access'})">Iniciar Sesión</v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script setup>
  import axios from 'axios'
  import Params from "../models/params";
  import { ref, reactive, computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { useVuelidate } from '@vuelidate/core';
  import { required,minLength, helpers } from '@vuelidate/validators';

  const route = useRoute();
  const params = ref(new Params);

  const form = reactive({
    pwd1: null,
    pwd2: null
  });

  const output = reactive({
    send: false,
    error: false,
    failed: false,
    message: null
  });

  const customRules = (value) => value == form.pwd1;
  const rules = computed(() => {
    return{
      pwd1: { 
        required: helpers.withMessage('Campo requerido.', required),
        minLength: helpers.withMessage('Mínimo 8 caracteres.', minLength(8))
      },
      pwd2: { 
        required: helpers.withMessage('Campo requerido.', required),
        customRules: helpers.withMessage('Las contraseñas no coinciden.', customRules)
      }
    }
  });

  const v$ = useVuelidate(rules, form);

  const visiblepwd1 = ref(false);
  const visiblepwd2 = ref(false);

  async function reset(){
    if(!await v$.value.$validate()){
      return
    }
    try {
      output.loading = true;
      const token = route.params.token;
      const document = route.params.document;
      const frm = new FormData;
      frm.append("action", "resetpassword");
      frm.append("token", token);
      frm.append("document", document); 
      frm.append("password", form.pwd1);
      const result = await eject(frm);
      output.loading = false;
      output.send = true;
      if(!result.status){
        output.message = result.message;
        output.failed = true;
      }
    } catch (err) {
      output.send = true;
      output.failed = true;
    }
  }

  function eject(f){
    return new Promise((resolve) => {
      axios.post(params.value.controller + 'beneficiario.php',f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
    })
  }
</script>